// extracted by mini-css-extract-plugin
export var askAiIcon = "_qy-9";
export var container = "_qy-0";
export var groupSeparator = "_qy-a";
export var highlight = "_qy-4";
export var resultIcon = "_qy-5";
export var resultItem = "_qy-7";
export var resultSubtitle = "_qy-3";
export var resultTitle = "_qy-2";
export var resultsList = "_qy-1";
export var searchGroup = "_qy-6";
export var selected = "_qy-8";